import { useReducer } from "react"
import { CompareDocuments } from "routes/schedule/compare/compare-documents"

export function Compare() {
    // new attempt -> remount, so the loaders restart and the retry shows the loading screen
    const [attempt, retry] = useReducer((a) => a + 1, 0)
    return <CompareDocuments key={attempt} retry={retry} />
}
